import PropTypes from 'prop-types';
// components
import { SplashScreen } from 'src/components/loading-screen';
//
import { ChatContext } from './chat-context';

export function ChatConsumer({ children }) {
  return (
    <ChatContext.Consumer>
      {(val) => (val.loading ? <SplashScreen /> : children)}
    </ChatContext.Consumer>
  );
}

ChatConsumer.propTypes = {
  children: PropTypes.node,
};